import { IFeeApplyTo } from 'features/settings/types';

export const feeAppliedToText: Record<IFeeApplyTo, string> = {
    [IFeeApplyTo.products]: 'Products',
    [IFeeApplyTo.services]: 'Services',
    [IFeeApplyTo.productsAndServices]: 'Products & Services',
    [IFeeApplyTo.shipping]: 'Shipping',
};
